import { useState, useEffect, useRef, useCallback } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../../Lib/contextLib';
import { getVideo, GetUserVideo } from '../../s3Func/s3Download';
import { API, Auth } from 'aws-amplify';
import PopUp from '../../Popup/logoutPopup';
import { CloudfrontVideoFormat } from '../../videos/CloudfrontVideoFormat';
import './Module9World.css';

import Learn from '../../Learn/Learn';
import Practice from './../../Unit1/Module4/PosturePractice';
import Day4Practice from './../Day4Practice/Day4Practice';
import SingingTime from '../../SingingTime/SingingTime';
import Celebrate from '../../Celebrate/Celebrate';
import Surprise from '../../SurpriseVideo/surprise';
import FollowTheBeatModule9 from '../../FollowTheBeat/FollowTheBeatModule9.js';
import presentSound from './../../Unit1/Module1/assets/ta_da_gift.mp3';
import loading from './../../loading-gif-png-5.gif';

// Constants
const TIMING = {
  BUTTON_AUDIO_DELAY: 700,
  ANIMATION_DELAY: 500,
  KEY_ANIMATION_DELAY: 1000,
  MONKEY_EAT_DELAY: 3000,
  IOS_VOICE_TIMEOUT: 5000,
};

const COIN_THRESHOLDS = {
  PRIZE_UNLOCK: 100,
  TWO_DIGIT: 10,
  THREE_DIGIT: 100,
};

const STEP_COMPLETED = {
  NOT_STARTED: 'notstarted',
  SINGING_TIME: 'singingtime',
  LEARN: 'learn',
  PRACTICE: 'practice',
  FOLLOW_THE_BEAT: 'followthebeat',
  CELEBRATE: 'celebrate',
  SURPRISE: 'surprise',
};

const MODULE_NAME = 'Respond';
const MODULE_NUM = 'MODULE9';
const SECTION_COMPLETED_THRESHOLD = 4;

const Module9World = () => {
  const { userHasAuthenticated } = useAppContext();
  const dispatch = useDispatch();
  const { module9 } = useSelector((state) => state.module9, shallowEqual);
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;

  const background = generateImageUrl('images/Module9Images/m9-BG-chromebook.png');
  const background2 = generateImageUrl('images/Module9Images/Day+Scene+Nav+Template+-+ML+%E2%80%93+5.png');
  const monkeyStill = generateImageUrl('images/Module4Images/Monkey+Practice+still.gif');
  const progressbar0 = generateImageUrl('images/Module4Images/ProgressBanana0.png');
  const progressbar1 = generateImageUrl('images/Module4Images/ProgressBanana1.png');
  const progressbar2 = generateImageUrl('images/Module4Images/ProgressBanana2.png');
  const progressbar3 = generateImageUrl('images/Module4Images/ProgressBanana2.png');
  const progressbarCompleted = generateImageUrl('images/Module4Images/Reward_Banana.png');
  const coinPick = generateImageUrl('images/Images/AwesomeCoin.png');
  const coinBar = generateImageUrl('images/Images/Coin+Counter.png');
  const journeyImage = generateImageUrl('images/Module1Images/bluejourneymap.svg');
  const logoutBtn = generateImageUrl('images/Module1Images/Logout.png');
  const reviewBtn = generateImageUrl('images/Module1Images/Button_Review.png');
  const rewardBtn = generateImageUrl('images/Module1Images/Button_Reward_3x.png')
  const celebrateBtn = generateImageUrl('images/Module1Images/Button_Celebrate.png');
  const learnBtn = generateImageUrl('images/Module1Images/Button_Learn.png');
  const practiceBtn = generateImageUrl('images/Module1Images/Button_Practice.png');
  const ftbBtn = generateImageUrl('images/Images/Button_FTB.png');
  const keyReward = generateImageUrl('images/Module4Images/Reward_Banana.png');
  const Waterfall2 = generateImageUrl('images/Module9Images/DailyReward_Waterfall2@3x.png');
  const Horse2 = generateImageUrl('images/Module9Images/DailyReward_Horse2.png');
  const Sytar1 = generateImageUrl('images/Module9Images/DailyReward_Sytar1.png');
  const Sytar2 = generateImageUrl('images/Module9Images/DailyReward_Sytar2.png');
  const Hat1 = generateImageUrl('images/Module9Images/DailyReward_Hat1.png');
  const Horse1 = generateImageUrl('images/Module9Images/DailyReward_Horse1.png');
  const Owl2 = generateImageUrl('images/Module9Images/DailyReward_Owl2.png');
  const Pheonix = generateImageUrl('images/Module9Images/DailyReward_Pheonix.png');
  const Hat2 = generateImageUrl('images/Module9Images/DailyReward_Hat2.png');
  const Owl1 = generateImageUrl('images/Module9Images/DailyReward_Owl1.png');
  const YetiBrown = generateImageUrl('images/Module9Images/DailyReward_Yeti_Brown.png');
  const Yeti = generateImageUrl('images/Module9Images/DailyReward_Yeti.png');
  const Bluejay = generateImageUrl('images/Module9Images/DailyReward_Bluejay.png');
  const Woodpecker = generateImageUrl('images/Module9Images/DailyReward_Woodpecker.png');
  const Waterfall1 = generateImageUrl('images/Module9Images/DailyReward_Waterfall1@3x.png');
  const Dragon = generateImageUrl('images/Module9Images/DailyReward_Dragon.png');
  const MedievalCastle = generateImageUrl('images/Module9Images/BigReward_Castle.png');
  const StoneSword = generateImageUrl('images/Module9Images/BigReward_StoneSword.png');
  const greenCheck = generateImageUrl('images/Module1Images/GreenCheck-Button.png');
  const SingingTimeIcon = generateImageUrl('images/Module1Images/Button_SingingTime.png');
  const AfterCelebrateVideo9 = 'a0417ec3c9e1f087fe7b9853987d/480.m3u8';
  const present = generateImageUrl('images/Images/Gift.png');

  const [reviewIcon, setReviewIcon] = useState(false);
  const [keyIcon, setKeyIcon] = useState(false);
  const [coinIcon, setCoinIcon] = useState(false);
  const [presentIcon, setPresentIcon] = useState(false);
  const [rewardOption1, setRewardOption1] = useState(null);
  const [rewardOption2, setRewardOption2] = useState(null);
  const [displayReward, setDisplayReward] = useState(false);

  const [displayLearn, setDisplayLearn] = useState(false);
  const [displayPractice, setDisplayPractice] = useState(false);
  const [displayDay4Practice, setDisplayDay4Practice] = useState(false);
  const [displaySingingTime, setDisplaySingingTime] = useState(false);
  const [displayCelebrate, setDisplayCelebrate] = useState(false);
  const [displaybody, setDisplayBody] = useState(true);
  const [displayGreenButton, setDisplayGreenButton] = useState(false);
  const [learn, setLearn] = useState('');
  const [singTime, setSingTime] = useState('');
  const [celebrate, setCelebrate] = useState('');
  const firstUpdate = useRef(true);
  const coinUpdate = useRef(true);
  const [displayIntroVideo, setDisplayIntroVideo] = useState(false);
  const [introVideo, setIntroVideo] = useState('');
  const [displaySurprise, setDisplaySurprise] = useState(false);
  const [surpriseVideo, setSurpriseVideo] = useState('');
  const [displayVoice, setDisplayVoice] = useState(false);
  const [animalVoice, setAnimalVoice] = useState('');
  const [day4Practice, setDay4Practice] = useState('');
  const [prize, setPrize] = useState(false);
  const [displayPrize, setDisplayPrize] = useState(false);
  const [checkStep, setCheckStep] = useState('');
  const [animal, setAnimal] = useState(monkeyStill);
  const [userInteracted, setUserInteracted] = useState(false);

  const keys5 = [
    progressbar0,
    progressbar1,
    progressbar2,
    progressbar2,
    progressbar3,
    progressbarCompleted,
  ];
  const keys4 = [
    progressbar0,
    progressbar1,
    progressbar2,
    progressbar3,
    progressbarCompleted,
  ];

  const [touchButton, setTouchButton] = useState(false);
  const [checkSound, setCheckSound] = useState(false);
  const [buttonSound, setButtonSound] = useState(false);
  const [rewardsFound, setRewardsFound] = useState(false);
  const [keyAnimationState, setKeyAnimationState] = useState('bounceIcons');
  const [coinAnimationState, setCoinAnimationState] = useState('bounceIcons');
  const [coinAudio, setCoinAudio] = useState(false);

  const [monkeyEat, setMonkeyEat] = useState(false);
  const [monkeyEatAudio, setMonkeyEatAudio] = useState(false);
  const [specialMessage, setSpecialMessage] = useState(false);
  const [watchConversation, setWatchConversation] = useState(false);
  const [practiceIntro, setPracticeIntro] = useState('');
  const [learnIntro, setLearnIntro] = useState('');
  const [ftbIntro, setFtbIntro] = useState('');
  const [celebrateIntro, setCelebrateIntro] = useState('');
  const [animalClose, setAnimalClose] = useState(false);
  const [playAnimalClose, setPlayAnimalClose] = useState(false);
  const [animalCloseAudio, setAnimalCloseAudio] = useState(false);
  const [showAnimal, setShowAnimal] = useState(false);
  const [animalState, setAnimalState] = useState('');
  const [amazingJob, setAmazingJob] = useState(false);
  const [displayFTB, setDisplayFTB] = useState(false);
  const [audioReady, setAudioReady] = useState(false);
  const [ftbInstructions, setFtbInstructions] = useState('');
  const [ftbInstructionsAudio, setFtbInstructionsAudio] = useState('');
  const [showReward, setShowReward] = useState(false);

  const [ftbMusic, setFTBMusic] = useState('');
  const [ftbInstruction, setFTBInstruction] = useState('');
  const [ftbInstructionGIF, setFTBInstructionGIF] = useState('');
  const [ftbCount, setFTBCount] = useState('');
  const [ftbTutorial1, setFTBTutorial1] = useState('');
  const [ftbTutorial2, setFTBTutorial2] = useState('');
  const [ftbWT, setFTBWalkThrough] = useState('');
  const influencers = [
    login.influencerid,
    login.influencerid1,
    login.influencerid2,
    login.influencerid3,
    login.influencerid4,
  ];

  const touchSound = new Audio(generateImageUrl('media/Module1Videos/touch_button.mp3'));

  // ==================== Audio & iOS Compatibility ====================
  // Utility function for delays
  const sleep = useCallback((ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }, []);

  const playButtonAudio = useCallback(() => {
    sleep(TIMING.BUTTON_AUDIO_DELAY).then(() => {
      setButtonSound(true);
    });
  }, []);

  // ==================== Media Loading ====================
  const getGifs = useCallback(() => {
    setMonkeyEat(getVideo('appfiles/posture/monkey_banana.gif', login));

    setMonkeyEatAudio(getVideo('appfiles/posture/monkey_eating.mp3', login));

    setSpecialMessage(getVideo('appfiles/respond/respond_special_message.gif', login));

    setWatchConversation(getVideo('appfiles/respond/respond_watch_conversation.gif', login));

    setAmazingJob(getVideo('appfiles/respond/respond_amazing_job.gif', login));

    setPracticeIntro(getVideo('appfiles/respond/respond_practice_intro.gif', login));

    setLearnIntro(getVideo('appfiles/respond/respond_learn_intro.gif', login));

    setFtbIntro(getVideo('appfiles/respond/respond_ftb_intro.gif', login));

    setFtbInstructions(getVideo('appfiles/respond/respond_ftb_instructions.gif', login));

    setFtbInstructionsAudio(getVideo('appfiles/respond/respond_ftb_instructions.mp3', login));

    setCelebrateIntro(getVideo('appfiles/respond/respond_celebrate_intro.gif', login));

    setAnimalClose(getVideo('appfiles/respond/respond_day_finished.gif', login));

    setAnimalCloseAudio(getVideo('appfiles/respond/respond_day_finished.mp3', login));

    setFTBInstruction(getVideo('appfiles/respond/respond_ftb_instructions.mp3', login));

    setFTBInstructionGIF(getVideo('appfiles/respond/respond_ftb_instructions.gif', login));

    setFTBMusic(getVideo('appfiles/respond/FTB respond song and counting.mp3', login));

    setFTBCount(getVideo('appfiles/respond/countingMonkey.gif', login));

    if (!module9.unlockedDays.day2) {
      setFTBTutorial1(getVideo('appfiles/greet/ftb_walkthrough_touch_circle.mp3', login));

      setFTBTutorial2(getVideo('appfiles/greet/ftb_walkthrough_count_touch.mp3', login));

      setFTBWalkThrough(getVideo('appfiles/respond/ftb_walkthrough_audio.mp3', login));
    }
  }, []);

  useEffect(() => {
    getGifs();
  }, [getGifs]);

  // ==================== iOS Detection ====================
  const isIOS = () => {
    return (
      [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod',
      ].includes(navigator.platform) ||
      // iPad on iOS 13 detection
      (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
    );
  };

  useEffect(() => {
    let timer;
    if (displayVoice && isIOS()) {
      timer = setTimeout(() => {
        setAudioReady(false);
        setDisplayVoice(false);
        setAnimalState('');
        setShowAnimal(false);
        document.getElementById('stillMonkey').style.display = 'block';
      }, TIMING.IOS_VOICE_TIMEOUT);
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [displayVoice]);

  useEffect(() => {
    let timer;
    if (playAnimalClose && isIOS()) {
      timer = setTimeout(() => {
        document.getElementById('stillMonkey').style.display = 'block';
        setPlayAnimalClose(false);
        module9.currentday === 8 ? closeDay9Video() : navigate('/respond/navigation');
      }, TIMING.IOS_VOICE_TIMEOUT);
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [playAnimalClose]);

  // iOS audio compatibility - trigger audio playback when state changes
  useEffect(() => {
    let timer;
    if (coinAudio && isIOS()) {
      timer = setTimeout(() => {
        dispatch({ type: 'MODULE9_SET_COIN', payload: module9.coins + 1 });
        setCoinAudio(false);
        setCoinAnimationState('bounceIcons');
        setCoinIcon(false);
        playButtonAudio();
      }, TIMING.IOS_VOICE_TIMEOUT);
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [coinAudio]);

  const createGameDetails = useCallback(
    (flag, reward, coin) => {
      const game_detail = module9.game_details;
      if (flag) {
        const flags = { flag, lastUpdated: new Date().toJSON() };
        game_detail.moduleFlags.push(flags);
      }
      if (coin >= 0) {
        game_detail.tokens_earned = coin;
      }
      if (reward) {
        const dailyRewards = [];
        for (const key in module9.rewards) {
          if (module9.rewards[key] === true) {
            const rewards = { type: key, x_multiplier: 1, y_multiplier: 1 };
            dailyRewards.push(rewards);
          }
        }
        game_detail.dailyRewards = dailyRewards;
      }
      dispatch({ type: 'MODULE9_SET_GameDetials', payload: game_detail });
    },
    [dispatch, module9.game_details, module9.rewards]
  );

  // ==================== Database & Game Logic ====================
  const updateProgress = async () => {
    const payload = {
      body: {
        id: login.studentid,
        module: MODULE_NAME,
        day_completed: module9.currentday,
        time_completed: new Date().toDateString(),
      },
    };
    try {
      await API.put('TIR', '/v3/student/progress', payload);
    } catch (error) {
      // Progress update failed silently
    }
  };

  useEffect(() => {
    if (
      (module9.reviewIcon === true || login.grade === 'Teacher Mode') &&
      module9.sectionCompleted === SECTION_COMPLETED_THRESHOLD
    ) {
      updateProgress();
      module9.sectionCompleted = 0;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [module9.sectionCompleted, module9.reviewIcon, login.grade]);

  const updateDB = async () => {
    const modulePayload = {
      body: {
        id: module9.moduleID,
        day_completed: module9.day_completed,
        step_completed: module9.stepCompleted,
        game_details: JSON.stringify(module9.game_details),
      },
    };

    try {
      await API.put('TIR', '/v3/student/module', modulePayload);
      if (displayGreenButton) {
        setAnimalVoice(null);
        setShowAnimal(true);
        setPlayAnimalClose(true);
        setAnimalState(animalClose);
        setDisplayGreenButton(false);
        setDisplayReward(false);
      }
    } catch (error) {
      const criticalSteps = [
        STEP_COMPLETED.NOT_STARTED,
        STEP_COMPLETED.LEARN,
        STEP_COMPLETED.PRACTICE,
        STEP_COMPLETED.CELEBRATE,
        STEP_COMPLETED.FOLLOW_THE_BEAT,
      ];
      if (criticalSteps.includes(module9.stepCompleted)) {
        window.alert('Connection is lost. Please login again.');
        dispatch({ type: 'CLEAR' });
        Auth.signOut();
        navigate('/');
      }
    }

    // Update student's current module
    const studentPayload = {
      body: {
        id: login.studentid,
        current_module: MODULE_NAME,
      },
    };
    try {
      await API.put('TIR', '/v3/student', studentPayload);
    } catch (error) {
      // Student update failed silently
    }
  };

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
    } else {
      if(login.grade !== "Teacher Mode" && login.grade !== 'Free Play'){
        updateDB();
      }
    }
  }, [module9.stepCompleted]);

  useEffect(() => {
    if (module9.coins >= COIN_THRESHOLDS.PRIZE_UNLOCK) {
      setPrize(true);
    }
    if (coinUpdate.current) {
      coinUpdate.current = false;
    } else {
      createGameDetails(false, false, module9.coins);
      updateDB();
    }
  }, [module9.coins]);

  // ==================== UI Handlers ====================
  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  // ==================== Progress & Step Management ====================
  useEffect(() => {
    if (module9.currentday <= module9.day_completed || login.grade === "Teacher Mode" || login.grade === "Free Play") {
      if(login.grade === "Teacher Mode" || login.grade === "Free Play"){
        setShowReward(true)
      }
      dispatch({ type: 'MODULE9_TOGGLE_REVIEW_ICON', payload: true });
      dispatch({ type: 'MODULE9_SET_KEY', payload: 4 });
      if (module9.currentday === 4 || module9.currentday === 8) {
        dispatch({ type: 'MODULE9_SET_KEY', payload: 5 });
      }
    } else {
      if (module9.stepCompleted === checkStep) {
        setCoinIcon(true);
      }
      dispatch({ type: 'MODULE9_TOGGLE_REVIEW_ICON', payload: false });
      if (module9.currentday === 4 && module9.day_completed === 3) {
        if (module9.stepCompleted === STEP_COMPLETED.NOT_STARTED) {
          dispatch({ type: 'MODULE9_SET_KEY', payload: 0 });
        } else if (module9.stepCompleted === STEP_COMPLETED.SINGING_TIME) {
          dispatch({ type: 'MODULE9_SET_KEY', payload: 1 });
        } else if (module9.stepCompleted === STEP_COMPLETED.LEARN) {
          dispatch({ type: 'MODULE9_SET_KEY', payload: 2 });
        } else if (module9.stepCompleted === STEP_COMPLETED.PRACTICE) {
          dispatch({ type: 'MODULE9_SET_KEY', payload: 3 });
        } else if (module9.stepCompleted === STEP_COMPLETED.FOLLOW_THE_BEAT) {
          dispatch({ type: 'MODULE9_SET_KEY', payload: 4 });
        } else if (module9.stepCompleted === STEP_COMPLETED.CELEBRATE) {
          setKeyIcon(true);
          dispatch({ type: 'MODULE9_SET_KEY', payload: 5 });
        }
        playButtonAudio();
      } else {
        if (module9.stepCompleted === STEP_COMPLETED.NOT_STARTED) {
          dispatch({ type: 'MODULE9_SET_KEY', payload: 0 });
        } else if (module9.stepCompleted === STEP_COMPLETED.LEARN) {
          dispatch({ type: 'MODULE9_SET_KEY', payload: 1 });
        } else if (module9.stepCompleted === STEP_COMPLETED.PRACTICE) {
          dispatch({ type: 'MODULE9_SET_KEY', payload: 2 });
        } else if (module9.stepCompleted === STEP_COMPLETED.FOLLOW_THE_BEAT) {
          dispatch({ type: 'MODULE9_SET_KEY', payload: 3 });
        } else if (module9.stepCompleted === STEP_COMPLETED.CELEBRATE) {
          if (module9.currentday === 8 && module9.day_completed === 7) {
            dispatch({ type: 'MODULE9_SET_KEY', payload: 4 });
            setPresentIcon(true);
          } else {
            setKeyIcon(true);
            dispatch({ type: 'MODULE9_SET_KEY', payload: 4 });
          }
        } else if (module9.stepCompleted === STEP_COMPLETED.SURPRISE) {
          dispatch({ type: 'MODULE9_SET_KEY', payload: 5 });
          setKeyIcon(true);
        }
        playButtonAudio();
      }
    }
  }, [module9.stepCompleted]);

  // ==================== Reward & Prize Functions ====================
  const selectReward = () => {
    return (
      <>
        <div className='rewards'>
          <div className='circle' id='rewardItemLeft2'>
            <img
              src={rewardOption1}
              alt=''
              onClick={() => {
                dispatch({
                  type: `MODULE9_SET_REWARD${module9.currentday}1`,
                  payload: true,
                });
                dispatch({
                  type: `MODULE9_SET_REWARD${module9.currentday}2`,
                  payload: false,
                });
                document.getElementById('rewardItemLeft2').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemRight2').style.borderColor =
                  'white';
                setTouchButton(true);
                setDisplayGreenButton(true);
              }}
            />
          </div>
          <div className='circle' id='rewardItemRight2'>
            <img
              src={rewardOption2}
              alt=''
              onClick={() => {
                dispatch({
                  type: `MODULE9_SET_REWARD${module9.currentday}2`,
                  payload: true,
                });
                dispatch({
                  type: `MODULE9_SET_REWARD${module9.currentday}1`,
                  payload: false,
                });
                document.getElementById('rewardItemRight2').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemLeft2').style.borderColor =
                  'white';
                setTouchButton(true);
                setDisplayGreenButton(true);
              }}
            />
          </div>
        </div>
        <div className='greenCheckDiv'>
          {displayGreenButton && (
            <img
              className='greenCheck'
              src={greenCheck}
              alt=''
              onClick={() => {
                setCheckSound(true);
                updateProgress();
                sleep(TIMING.ANIMATION_DELAY).then(() => {
                  createGameDetails(false, true);
                  if (login.grade === 'Teacher Mode' || login.grade === 'Free Play') {
                    updateDB();
                  }
                  dispatch({
                    type: `MODULE9_SET_DAY_UNLOCK${module9.currentday + 1}`,
                    payload: true,
                  });
                  dispatch({
                    type: 'MODULE9_SET_dayCompleted',
                    payload: module9.currentday === 8 ? 9 : module9.currentday,
                  });
                  dispatch({
                    type: 'MODULE9_SET_stepCompleted',
                    payload: STEP_COMPLETED.NOT_STARTED,
                  });
                });
              }}
            />
          )}
        </div>
      </>
    );
  };

  const openPrize = () => {
    return (
      <>
        <div className='rewards'>
          <div className='circle' id='rewardItemLeft'>
            <img
              src={MedievalCastle}
              alt=''
              onClick={() => {
                
                dispatch({ type: `MODULE9_SET_PRIZE1`, payload: true });
                dispatch({ type: `MODULE9_SET_PRIZE2`, payload: false });
                document.getElementById('rewardItemLeft').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemRight').style.borderColor =
                  'white';
                setTouchButton(true);
                setDisplayGreenButton(true);
              }}
            />
          </div>
          <div className='circle' id='rewardItemRight'>
            <img
              src={StoneSword}
              alt=''
              onClick={() => {
                
                dispatch({ type: `MODULE9_SET_PRIZE2`, payload: true });
                dispatch({ type: `MODULE9_SET_PRIZE1`, payload: false });
                document.getElementById('rewardItemRight').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemLeft').style.borderColor =
                  'white';
                setTouchButton(true);
                setDisplayGreenButton(true);
              }}
            />
          </div>
        </div>
        <div className='greenCheckDiv'>
          {displayGreenButton && (
            <img
              className='greenCheck'
              src={greenCheck}
              alt=''
              onClick={() => {
                
                setDisplayPrize(false);
                setCheckSound(true);
                sleep(500).then(() => {
                  setDisplayGreenButton(false);
                  createGameDetails(false, true);
                  dispatch({
                    type: 'MODULE9_SET_COIN',
                    payload: module9.coins - 100,
                  });
                });
              }}
            />
          )}
        </div>
      </>
    );
  };

  useEffect(() => {
    switch (module9.currentday) {
      case 1:
        setRewardOption1(Yeti);
        setRewardOption2(YetiBrown);
        break;
      case 2:
        setRewardOption1(Sytar1);
        setRewardOption2(Sytar2);
        break;
      case 3:
        setRewardOption1(Bluejay);
        setRewardOption2(Woodpecker);
        break;
      case 4:
        setRewardOption1(Waterfall1);
        setRewardOption2(Waterfall2);
        break;
      case 5:
        setRewardOption1(Dragon);
        setRewardOption2(Pheonix);
        break;
      case 6:
        setRewardOption1(Horse1);
        setRewardOption2(Horse2);
        break;
      case 7:
        setRewardOption1(Owl1);
        setRewardOption2(Owl2);
        break;
      case 8:
        setRewardOption1(Hat1);
        setRewardOption2(Hat2);
        break;
      default:
        setDisplayGreenButton(true);
        break;
    }
  }, [
    keyIcon,
    Bluejay,
    Dragon,
    Hat1,
    Hat2,
    Horse1,
    Horse2,
    Owl1,
    Owl2,
    Pheonix,
    Sytar1,
    Sytar2,
    Waterfall1,
    Waterfall2,
    Woodpecker,
    Yeti,
    YetiBrown,
    module9.currentday,
  ]);

  // ==================== Module Opening Functions ====================
  const displayReview = () => {
    if (module9.currentday === 4) {
      return (
        <>
          <div className='world2reviewContainer'>
            <img
              className='reviewBtns41'
              src={SingingTimeIcon}
              alt='singing button'
              onClick={() => {
                
                displaySinging();
              }}
            />
            <img
              className='reviewBtns42'
              src={learnBtn}
              alt='learn button'
              onClick={() => {
                
                openLearn();
              }}
            />
            <img
              className='reviewBtns43'
              src={practiceBtn}
              alt='practice button'
              onClick={() => {
                
                openPractice();
              }}
            />
            <img
              className='reviewBtns44'
              src={ftbBtn}
              alt='ftb button'
              onClick={() => {
                
                openFTB();
              }}
            />
            <img
              className='reviewBtns45'
              src={celebrateBtn}
              alt='celebrate button'
              onClick={() => {
                
                openCelebrate();
              }}
            />
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className='world2reviewContainer'>
            <img
              className='reviewBtns1'
              src={learnBtn}
              alt='learn button'
              onClick={() => {
                
                openLearn();
              }}
            />
            <img
              className='reviewBtns2'
              src={practiceBtn}
              alt='practice button'
              onClick={() => {
                
                openPractice();
              }}
            />
            <img
              className='reviewBtns3'
              src={ftbBtn}
              alt='ftb button'
              onClick={() => {
                
                openFTB();
              }}
            />
            <img
              className='reviewBtns4'
              src={celebrateBtn}
              alt='celebrate button'
              onClick={() => {
                
                openCelebrate();
              }}
            />
          </div>
        </>
      );
    }
  };

  const introduction = () => {
    return (
      <div>
        <CloudfrontVideoFormat
          source={introVideo}
          back='/respond/navigation'
          background={background}
          token={login.cookie}
          ended={() => {
            // here is where you can add dispatch functions
            setDisplayIntroVideo(false);
            setDisplayBody(true);
            if (module9.currentday === 4) {
              dispatch({ type: 'MODULE9_SET_KEY', payload: 1 });
              playButtonAudio();
            }
            if (module9.day_completed === 9) {
              navigate('/respond/navigation');
            }
          }}
        />
      </div>
    );
  };

  const openLearn = async () => {
    let song = getVideo('appfiles/respond/respond_full_song_example.m4a', login);
    let video = getVideo('appfiles/respond/learn_video.mp4', login);
    switch (module9.currentday) {
      case 1:
        setLearn(
          <Learn
            video='3c246fec3a3777165bd3a9ec845d/480.m3u8'
            songVideo={video}
            closingVideo='c1a71964787474466451ecf38f05/480.m3u8'
            destiny='/respond'
            song={song}
            back='/respond'
            background={background}
            setDisplayLearn={setDisplayLearn}
            step_completed={`${MODULE_NUM}_SET_stepCompleted`}
            module={module9}
          />
        );
        break;
      case 2:
        setLearn(
          <Learn
            video='b923a68c87406affc00252c0288d/480.m3u8'
            songVideo={video}
            closingVideo='59bc6c2936f71bdb91368f3de203/480.m3u8'
            destiny='/respond'
            song={song}
            back='/respond'
            background={background}
            setDisplayLearn={setDisplayLearn}
            step_completed={`${MODULE_NUM}_SET_stepCompleted`}
            module={module9}
          />
        );
        break;
      case 3:
        setLearn(
          <Learn
            video='16684c134ce6168460fbaaf57da4/480.m3u8'
            songVideo={video}
            closingVideo='42bbdd701d7eb6c85a15c6fc280f/480.m3u8'
            destiny='/respond'
            song={song}
            back='/respond'
            background={background}
            setDisplayLearn={setDisplayLearn}
            step_completed={`${MODULE_NUM}_SET_stepCompleted`}
            module={module9}
          />
        );
        break;
      default:
        setAnimalVoice(getVideo('appfiles/respond/respond_learn_intro.mp3', login));
        // setDisplayVoice(true);
        setAnimalState(learnIntro);
        setShowAnimal(true);
        await GetUserVideo(`userfiles/${module9.StudentID}/respond_play_day_music.m4a`).then((data) => {
          fetch(data).then((response) => {
            GetUserVideo(`influencers/${influencers[module9.currentday-4]}/respond_affirmation.mp4`).then((influencerVideo) => {
              if (response.status === 200) {
                setLearn(
                  <Learn
                    songVideo={video}
                    destiny='/respond'
                    song={data}
                    back='/respond'
                    background={background}
                    setDisplayLearn={setDisplayLearn}
                    step_completed={`${MODULE_NUM}_SET_stepCompleted`}
                    module={module9}
                    instrumental={getVideo('appfiles/respond/respond_full_song.m4a', login)}
                    influencerVideo={influencerVideo}
                  />
                );
              } else {
                setLearn(
                  <Learn
                    songVideo={video}
                    destiny='/respond'
                    song={song}
                    back='/respond'
                    background={background}
                    setDisplayLearn={setDisplayLearn}
                    step_completed={`${MODULE_NUM}_SET_stepCompleted`}
                    module={module9}
                    influencerVideo={influencerVideo}
                  />
                );
              }
            });
          });
        });
        break;
    }
    setDisplayLearn(true);
  };

  const openPractice = async () => {
    const text = [
      'Press record and say, "Cool!"',
      'Press record and say, "Awesome!"',
      'Press record and say, "Yummy!"',
      'Press record and say, "Fun!"',
      'Press record and say, "That is great!"',
    ];
    switch (module9.currentday) {
      case 1:
        setDisplayPractice(true);
        break;
      case 2:
        setDisplayPractice(true);
        break;
      case 3:
        setDisplayPractice(true);
        break;
      default:
        const introVideo = 'e29f5890e91be9f19dd16dc0e82f/480.m3u8';
        setAnimalVoice(getVideo('appfiles/respond/respond_practice_intro.mp3', login));
        setAnimalState(practiceIntro);
        setShowAnimal(true);
        let voice1 = getVideo(`appfiles/respond/respond_practice_record_${module9.currentday + 1}.mp3`, login);
        let voice2 = getVideo('appfiles/respond/respond_practice_special_message.mp3', login);
        let voice3 = getVideo('appfiles/respond/respond_practice_watch_conversation.mp3', login);
        let voice4 = getVideo('appfiles/respond/respond_amazing_job.mp3', login);
        let response = getVideo(`appfiles/respond/respond_respond_${module9.currentday + 1}.mp4`, login);
        let greeting = getVideo(`appfiles/respond/respond_greeting_${module9.currentday + 1}.mp4`, login);
        let question7 = getVideo(`appfiles/respond/respond_question_${module9.currentday + 1}.mp4`, login);
        let acknowledge7 = getVideo(`appfiles/respond/respond_acknowledge_${module9.currentday + 1}.mp4`, login);
        await GetUserVideo(`influencers/${influencers[module9.currentday-4]}/respond_video_message.mp4`).then((influencerVideo) => {
          GetUserVideo(`userfiles/${module9.StudentID}/greet_practice_video_${module9.currentday + 1}.mp4`).then((greetingResponse) => {
            GetUserVideo(`userfiles/${module9.StudentID}/answer_practice_video_${module9.currentday + 1}.mp4`).then((response7) => {
              GetUserVideo(`userfiles/${module9.StudentID}/ask_practice_video_${module9.currentday + 1}.mp4`).then((ask) => {
                setDay4Practice(
                  <Day4Practice
                    bigAnimal={true}
                    module={module9}
                    celebrateVideo={introVideo}
                    response7={response7}
                    greetingResponse={greetingResponse}
                    acknowledge7={acknowledge7}
                    question7={question7}
                    ask={ask}
                    background={background}
                    influencerVideo={influencerVideo}
                    question={response}
                    response={response}
                    text={text[module9.currentday - 4]}
                    voice1={voice1}
                    voice2={voice2}
                    voice3={voice3}
                    voice4={voice4}
                    animate2={specialMessage}
                    animate3={watchConversation}
                    animate4={amazingJob}
                    name={`respond_practice_video_${
                      module9.currentday + 1
                    }.mp4`}
                    greeting={greeting}
                    closeVoice={voice4}
                    animal={animal}
                    setDisplayDay4Practice={
                      setDisplayDay4Practice
                    }
                    moduleNum={MODULE_NUM}
                  />
                );
              });
            });
          });
        });
        setDisplayDay4Practice(true);
        break;
    }
  };

  const openFTB = async () => {
    switch (module9.currentday) {
      case 1:
        break;
      case 2:
        break;
      case 3:
        break;

      default:
        setDisplayFTB(true);
        setAnimalVoice(getVideo('appfiles/respond/respond_ftb_intro.mp3', login));
        // setDisplayVoice(true);
        setAnimalState(ftbIntro);
        setShowAnimal(true);
        break;
    }
    setDisplayFTB(true);
  };

  const openCelebrate = async () => {
    const celebrateVideo1 = 'f78f227dbdcdb38df88d923134d7/480.m3u8';
    const celebrateVideo2 = '0b6d10f92d2a4f96e62fabbdf050/480.m3u8';
    const celebrateVideo3 = '71a8893d1b8fec3c27badf911c81/480.m3u8';

    switch (module9.currentday) {
      case 1:
        setCelebrate(
          <Celebrate
            module={module9}
            celebrateVideo={celebrateVideo1}
            background={background}
            setDisplayCelebrate={setDisplayCelebrate}
            moduleNum={MODULE_NUM}
          />
        );
        break;
      case 2:
        setCelebrate(
          <Celebrate
            module={module9}
            celebrateVideo={celebrateVideo2}
            background={background}
            setDisplayCelebrate={setDisplayCelebrate}
            moduleNum={MODULE_NUM}
          />
        );
        break;
      case 3:
        setCelebrate(
          <Celebrate
            module={module9}
            celebrateVideo={celebrateVideo3}
            background={background}
            setDisplayCelebrate={setDisplayCelebrate}
            moduleNum={MODULE_NUM}
          />
        );
        break;
      default:
        setAnimalVoice(getVideo('appfiles/respond/respond_celebrate_intro.mp3', login));
        // setDisplayVoice(true);
        setAnimalState(celebrateIntro);
        setShowAnimal(true);
        let voice1 = getVideo('appfiles/respond/respond_celebrate_record_do_all.mp3', login);
        let voice2 = getVideo('appfiles/respond/respond_celebrate_say_yes.mp3', login);
        let voice3 = getVideo('appfiles/respond/respond_amazing_job.mp3', login);
        await GetUserVideo(`influencers/${influencers[module9.currentday-4]}/respond_affirmation.mp4`).then((influencerVideo) => {
          setCelebrate(
            <Celebrate
              module={module9}
              background={background}
              voice1={voice1}
              voice2={voice2}
              voice3={voice3}
              text={
                'Record yourself in an excited voice and say, "I can do it all!"'
              }
              name={`respond_celebration_surprise_${
                module9.currentday + 1
              }.mp4`}
              influencerVideo={influencerVideo}
              animation={amazingJob}
              animal={animal}
              setDisplayCelebrate={setDisplayCelebrate}
              moduleNum={MODULE_NUM}
              bigAnimal={true}
            />
          );
        });
        break;
    }
    setDisplayCelebrate(true);
  };

  const displaySinging = async () => {
    const introVideo = '74ab22a906daf14922e6320d13e6/480.m3u8';
    let noteVideo = getVideo('appfiles/respond/respond_student_notes.mp4', login);
    let singingMusic = getVideo('appfiles/respond/respond_full_song_example.m4a', login);
    let instrumental = getVideo('appfiles/respond/respond_instrumental.m4a', login);
    setSingTime(
      <SingingTime
        introVideo={introVideo}
        demoMusic={singingMusic}
        singingVideo={noteVideo}
        background={background}
        singingMusic={singingMusic}
        setDisplaySingingTime={setDisplaySingingTime}
        module={module9}
        moduleNum={MODULE_NUM}
        name='respond'
        instrumental={instrumental}
        instrumentalURL={'appfiles/respond/respond_full_song.m4a'}
      />
    );
    setDisplaySingingTime(true);
  };

  const getSurprise = async () => {
    const usePhoto = [
      {
        video: `influencers/${login.influencerid}/respond_affirmation.mp4`,
      },
      {
        video: `userfiles/${module9.StudentID}/respond_celebration_surprise_5.mp4`,
      },
      {
        video: `influencers/${login.influencerid1}/respond_affirmation.mp4`,
      },
      {
        video: 'appfiles/respond/respond_greeting_5.mp4',
      },
      {
        video: `userfiles/${module9.StudentID}/greet_practice_video_5.mp4`,
      },
      {
        video: `appfiles/respond/respond_question_5.mp4`,
      },
      {
        video: `userfiles/${module9.StudentID}/answer_practice_video_5.mp4`,
      },
      {
        video: 'appfiles/respond/respond_acknowledge_5.mp4',
      },
      {
        video: `userfiles/${module9.StudentID}/ask_practice_video_5.mp4`,
      },
      {
        video: `appfiles/respond/respond_respond_5.mp4`,
      },
      {
        video: `userfiles/${module9.StudentID}/respond_practice_video_5.mp4`,
      },
      {
        video: `influencers/${login.influencerid2}/respond_video_message.mp4`,
      },
      {
        video: `influencers/${login.influencerid3}/respond_affirmation.mp4`,
      },
      {
        video: `userfiles/${module9.StudentID}/respond_celebration_surprise_9.mp4`,
      },
      {
        video: `influencers/${login.influencerid4}/respond_affirmation.mp4`,
      },
    ];

    for (let i = 0; i < usePhoto.length; i++) {
      await GetUserVideo(usePhoto[i].video, login).then((data) => {
        usePhoto[i].video = data;
      });
    }

    return usePhoto;
  };

  const playSurpriseVideo = async () => {
    await getSurprise().then((photo) => {
      setSurpriseVideo(
        <Surprise
          background={background}
          music={getVideo('appfiles/respond/respond_instrumental.m4a', login)}
          animal={animal}
          back={'/'}
          slides={photo}
          setDisplaySurprise={setDisplaySurprise}
        />
      );
    });
    setDisplaySurprise(true);
    setKeyIcon(true);
    setPresentIcon(false);
  };

  // ==================== Animation Functions ====================
  const coinAnimation = () => {
    setCoinAnimationState('coinAnimation');
    setCoinAudio(true);
  };

  const rewardAnimation = () => {
    setKeyAnimationState('fade-out');
    sleep(TIMING.KEY_ANIMATION_DELAY).then(() => {
      setKeyIcon(false);
      setAnimalVoice(monkeyEatAudio);
      // setDisplayVoice(true);
      setAnimalState(monkeyEat);
      setShowAnimal(true);
      sleep(TIMING.MONKEY_EAT_DELAY).then(() => {
        setRewardsFound(true);
        setDisplayReward(true);
      });
    });
  };

  const closeDay9Video = () => {
    setDisplayIntroVideo(true);
    setDisplayBody(false);
    setIntroVideo(AfterCelebrateVideo9);
  };

  return (
    <>
      {coinAudio && (
        <audio
          autoPlay
          onEnded={() => {
            dispatch({ type: 'MODULE9_SET_COIN', payload: module9.coins + 1 });
            setCoinAudio(false);
            setCoinAnimationState('bounceIcons');
            setCoinIcon(false);
            playButtonAudio();
          }}
        >
          <source
            src={
              generateImageUrl('media/Module5Videos/earn_token.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      {checkSound && (
        <audio
          autoPlay
          onEnded={() => {
            setCheckSound(false);
          }}
        >
          <source
            src={
              generateImageUrl('media/Module1Videos/button_accept_item.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      {playAnimalClose && (
        <audio
          autoPlay
          onPlay={() => {
            setAudioReady(true);
            document.getElementById('stillMonkey').style.display = 'none';
          }}
          onEnded={() => {
            document.getElementById('stillMonkey').style.display = 'block';
            setPlayAnimalClose(false);
            module9.currentday === 8
              ? closeDay9Video()
              : navigate('/respond/navigation');
          }}
        >
          <source src={animalCloseAudio} type='audio/mp3' />
        </audio>
      )}
      {rewardsFound && (
        <audio autoPlay>
          <source
            src={
              generateImageUrl('media/Module2Videos/daily_rewards_present.mp3')
            }
          ></source>
        </audio>
      )}
      {touchButton && (
        <audio
          autoPlay
          onEnded={() => {
            setTouchButton(false);
          }}
        >
          <source
            src={
              generateImageUrl('media/Module1Videos/touch_button.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      {buttonSound && (
        <audio
          autoPlay
          onEnded={() => {
            setButtonSound(false);
          }}
        >
          <source
            src={
              generateImageUrl('media/Module1Videos/button_bouncing.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}

      {displayVoice && (
        <audio
          autoPlay
          onPlay={() => {
            setAudioReady(true);
            document.getElementById('stillMonkey').style.display = 'none';
          }}
          onEnded={() => {
            setAudioReady(false);
            setDisplayVoice(false);
            setAnimalState('');
            setShowAnimal(false);
            document.getElementById('stillMonkey').style.display = 'block';
          }}
        >
          <source src={animalVoice}></source>
        </audio>
      )}
      {displayIntroVideo && introduction()}
      {!showAnimal && displayLearn && learn}
      {displayPractice && (
        <Practice
          world2={true}
          setDisplayPractice={setDisplayPractice}
          background={background}
          stepComplete={`${MODULE_NUM}_SET_stepCompleted`}
          module={module9}
        />
      )}
      {!showAnimal && displayDay4Practice && day4Practice}
      {!showAnimal && displayFTB && (
        <FollowTheBeatModule9
          setDisplayFTB={setDisplayFTB}
          awesomeJob={amazingJob}
          instruction={ftbInstruction}
          instructionGIF={ftbInstructionGIF}
          song={ftbMusic}
          count={ftbCount}
          tutorial1={ftbTutorial1}
          tutorial2={ftbTutorial2}
          walkthrough={ftbWT}
          stepComplete={`${MODULE_NUM}_SET_stepCompleted`}
          module={module9}
          score={'ftb_respond'}
        />
      )}
      {!showAnimal && displayCelebrate && celebrate}
      {displaySingingTime && singTime}
      {displaySurprise && surpriseVideo}
      {((displaybody &&
        !displayLearn &&
        !displayPractice &&
        !displaySingingTime &&
        !displayCelebrate &&
        !displaySurprise &&
        !displayFTB &&
        !displayDay4Practice) ||
        showAnimal) && (
        <div
          className='respondWorldBody'
          style={{
            backgroundImage: `url(${
              generateImageUrl('images/Module9Images/Day+Scene+Nav+Template+-+ML+%E2%80%93+5.png')
            })`,
          }}
        >
          <div className='tree_rewards'>
            {module9.rewards.Owl2 && <img className='Owl2' src={Owl2} alt='' />}
            {module9.rewards.Pheonix && (
              <img className='Pheonix' src={Pheonix} alt='' />
            )}
            {module9.rewards.Owl1 && <img className='Owl1' src={Owl1} alt='' />}
            {module9.rewards.Woodpecker && (
              <img className='Woodpecker' src={Woodpecker} alt='' />
            )}
            <img className='respondWorldTree' src={generateImageUrl('images/Module9Images/U2m4.png')} alt='trre' />
          </div>
          <div className='navigation'>
            <img
              className='logoutBtn'
              src={logoutBtn}
              alt='Logout Button'
              onClick={(e) => {
                
                togglePopup();
              }}
            />
            <img
              className='JourneyBlueImage'
              src={journeyImage}
              alt='Navigation blue world'
              onClick={() => {
                
                navigate('/respond/navigation');
              }}
            />
          </div>
          {isOpen && (
            <PopUp
              content={
                <>
                  <b id='title'>
                    Are you sure you want to leave?
                    <br />
                  </b>
                  <button
                    id='logoutButton1'
                    className='logoutButton'
                    onClick={() => {
                      navigate('/');
                      userHasAuthenticated(false);
                      localStorage.setItem('token', 'false');
                    }}
                  >
                    YES
                  </button>
                  <button
                    id='logoutButton2'
                    className='logoutButton'
                    onClick={togglePopup}
                  >
                    NO
                  </button>
                </>
              }
              handleClose={togglePopup}
            />
          )}
          {prize && (
            <audio autoPlay>
              <source src={presentSound}></source>
            </audio>
          )}

          {prize && (
            <img
              className='prize'
              src={
                generateImageUrl('images/Images/prize.png')
              }
              alt='Logout Button'
              onClick={() => {
                
                setPrize(false);
                sleep(TIMING.KEY_ANIMATION_DELAY + 400).then(() => {
                  sleep(TIMING.KEY_ANIMATION_DELAY).then(() => {
                    setDisplayPrize(true);
                  });
                });
              }}
            />
          )}
          {prize && (
            <button
              className='prize-button'
              onClick={() => {
                
                setPrize(false);
                setDisplayPrize(true);
              }}
            >
              {' '}
              <h5>Click Here</h5>
            </button>
          )}
          {displayPrize && openPrize()}

          <div className='Monkey_Container'>
            {module9.rewards.Hat2 && <img className='Hat2' src={Hat2} alt='' />}
            {module9.rewards.Hat1 && <img className='Hat1' src={Hat1} alt='' />}
            <img
              className='monkeyCharacter'
              id='stillMonkey'
              src={animal}
              alt='monkey Icon'
            />
            {showAnimal && (
            <img
              className='monkeyCharacter'
              style={audioReady ? {} : { display: 'none' }}
              src={animalState}
              alt='monkey Icon'
              onLoad={() => setDisplayVoice(true)}
              onError={() => setShowAnimal(false)}
            />
          )}
          </div>
          {showAnimal && !audioReady && <img id='loading' src={loading} />}

          <div className='scoreBar'>
            <img
              className='scoreKey'
              src={coinBar}
              alt='crab Icon'
              
            />
            {module9.coins < COIN_THRESHOLDS.TWO_DIGIT && (
              <h5 className='scoretext1'>{module9.coins}</h5>
            )}
            {module9.coins >= COIN_THRESHOLDS.TWO_DIGIT && module9.coins < COIN_THRESHOLDS.THREE_DIGIT && (
              <h5 className='scoretext10'>{module9.coins}</h5>
            )}
            {module9.coins >= COIN_THRESHOLDS.THREE_DIGIT && (
              <h5 className='scoretext100'>{module9.coins}</h5>
            )}
            <p className='scoretext'>{COIN_THRESHOLDS.PRIZE_UNLOCK}</p>
          </div>

          {module9.currentday === 4 || module9.currentday === 8 ? (
            <div className='progressBar3'>
              <img
                className='progressKey4'
                src={keys5[module9.keys]}
                alt='crab Icon'
              />
              <h3 className='progresstext3'>{module9.keys}/5</h3>
            </div>
          ) : (
            <div className='progressBar3'>
              <img
                className='progressKey4'
                src={keys4[module9.keys]}
                alt='crab Icon'
              />
              <h3 className='progresstext3'>{module9.keys}/4</h3>
            </div>
          )}

          {!showAnimal && !module9.reviewIcon && !coinIcon && !displayPrize && (
            <div className='actionBtnDiv'>
              {module9.currentday === 4 &&
                module9.stepCompleted === STEP_COMPLETED.NOT_STARTED && (
                  <img
                    className='actionBtn2'
                    id='bounceIcons'
                    src={SingingTimeIcon}
                    alt='learn button'
                    onClick={() => {
                      
                      setTouchButton(true);
                      sleep(TIMING.ANIMATION_DELAY).then(() => {
                        displaySinging();
                        setCheckStep(STEP_COMPLETED.SINGING_TIME);
                      });
                    }}
                  />
                )}
              {module9.currentday !== 4 &&
                module9.stepCompleted === STEP_COMPLETED.NOT_STARTED && (
                  <img
                    className='actionBtn2'
                    id='bounceIcons'
                    src={learnBtn}
                    alt='learn button'
                    onClick={() => {
                      
                      setTouchButton(true);
                      sleep(TIMING.ANIMATION_DELAY).then(() => {
                        openLearn();
                        setCheckStep(STEP_COMPLETED.LEARN);
                      });
                    }}
                  />
                )}

              {module9.stepCompleted === STEP_COMPLETED.LEARN && (
                <img
                  className='actionBtn2'
                  id='bounceIcons'
                  src={practiceBtn}
                  alt='practice button'
                  onClick={() => {
                    
                    touchSound.play();
                    sleep(TIMING.ANIMATION_DELAY).then(() => {
                      openPractice();
                      setCheckStep(STEP_COMPLETED.PRACTICE);
                    });
                  }}
                />
              )}

              {module9.stepCompleted === STEP_COMPLETED.PRACTICE && (
                <img
                  className='actionBtn2'
                  id='bounceIcons'
                  src={ftbBtn}
                  alt='celebrate button'
                  onClick={() => {
                    
                    setTouchButton(true);
                    sleep(TIMING.ANIMATION_DELAY).then(() => {
                      openFTB();
                      setCheckStep(STEP_COMPLETED.FOLLOW_THE_BEAT);
                    });
                  }}
                />
              )}

              {module9.stepCompleted === STEP_COMPLETED.FOLLOW_THE_BEAT && (
                <img
                  className='actionBtn2'
                  id='bounceIcons'
                  src={celebrateBtn}
                  alt='celebrate button'
                  onClick={() => {
                    
                    setTouchButton(true);
                    sleep(TIMING.ANIMATION_DELAY).then(() => {
                      openCelebrate();
                      setCheckStep(STEP_COMPLETED.CELEBRATE);
                    });
                  }}
                />
              )}

              {module9.stepCompleted === STEP_COMPLETED.SINGING_TIME && (
                <img
                  className='actionBtn2'
                  id='bounceIcons'
                  src={learnBtn}
                  alt='singing button'
                  onClick={() => {
                    
                    setTouchButton(true);
                    sleep(TIMING.ANIMATION_DELAY).then(() => {
                      openLearn();
                      setCheckStep(STEP_COMPLETED.LEARN);
                    });
                  }}
                />
              )}
            </div>
          )}

          {!displayVoice && coinIcon && !displayPrize && (
            <div className='actionBtnDiv'>
              {module9.reviewIcon === false && (
                <img
                  id={coinAnimationState}
                  src={coinPick}
                  alt='reward key'
                  style={{
                    position: 'absolute',
                    top: '50vh',
                    left: '50vw',
                    width: '100px',
                    height: '100px',
                    marginLeft: '-50px',
                    marginTop: '-50px',
                    zIndex: 10,
                  }}
                  onClick={() => {
                    
                    coinAnimation();
                  }}
                />
              )}
            </div>
          )}

          {!displayPrize &&
            !showAnimal &&
            !displayReward && (
              <div className='actionBtnDiv'>
                {module9.reviewIcon && (
                <img
                  className={showReward ? 'actionBtn3' : 'actionBtn2'}
                  src={reviewBtn}
                  alt='review button'
                  onClick={() => {
                    
                    setReviewIcon(!reviewIcon);
                  }}
                  />)}
                {showReward && (
                  <img
                    src={rewardBtn}
                    className='actionBtn4'
                    alt='review button'
                    onClick={() => {
                      
                      setTouchButton(true);
                      rewardAnimation();
                    }}
                />)}
                {module9.reviewIcon && reviewIcon && displayReview()}
              </div>
            )}

          {!coinIcon &&
            keyIcon &&
            !displayPrize &&
            module9.reviewIcon === false && (
              <img
                id={keyAnimationState}
                className='keyRewards'
                style={{
                  width: '150px',
                  height: '50px',
                  marginLeft: '-75px',
                  zIndex: 100,
                }}
                src={keyReward}
                alt='reward key'
                onClick={() => {
                  
                  rewardAnimation();
                }}
              />
            )}
          {displayReward && selectReward()}

          {!displayPrize && !coinIcon && presentIcon && (
            <img
              className='present'
              style={{
                width: '84px',
                height: '100px',
                marginLeft: '-42px',
                zIndex: 10,
              }}
              id='bounceIcons'
              src={present}
              alt='gift'
              onClick={() => {
                
                playSurpriseVideo();
              }}
            />
          )}
          {!displayPrize && !coinIcon && presentIcon && (
            <audio autoPlay>
              <source src={presentSound}></source>
            </audio>
          )}

          {module9.rewards.Waterfall2 && (
            <img className='Waterfall2' src={Waterfall2} alt='' />
          )}
          {module9.rewards.Waterfall1 && (
            <img className='Waterfall1' src={Waterfall1} alt='' />
          )}
          {module9.rewards.Horse2 && (
            <img className='Horse2' src={Horse2} alt='' />
          )}
          {module9.rewards.Sytar1 && (
            <img className='Sytar1' src={Sytar1} alt='' />
          )}
          {module9.rewards.Sytar2 && (
            <img className='Sytar2' src={Sytar2} alt='' />
          )}
          {module9.rewards.Horse1 && (
            <img className='Horse1' src={Horse1} alt='' />
          )}
          {module9.rewards.Dragon && (
            <img className='Dragon1' src={Dragon} alt='' />
          )}
          {module9.rewards.Yeti && <img className='Yeti' src={Yeti} alt='' />}
          {module9.rewards.YetiBrown && (
            <img className='YetiBrown' src={YetiBrown} alt='' />
          )}
          {module9.rewards.Bluejay && (
            <img className='Bluejay' src={Bluejay} alt='' />
          )}
          {module9.rewards.MedievalCastle && (
            <img className='MedievalCastle' src={MedievalCastle} alt='' />
          )}
          {module9.rewards.StoneSword && (
            <img className='StoneSword' src={StoneSword} alt='' />
          )}
        </div>
      )}
    </>
  );
};
export default Module9World;
